import React from 'react';

import BusinessButton from '@/components/business-button/business-button';

import styles from './b2b-back-to-latest-article.module.scss';

interface Props {
    latestArticleUrl: string;
}

const B2BBackToLatestArticle: React.FC<Props> = (props: Props) => {
    const { latestArticleUrl } = props;

    return (
        <div className={styles.backToLatestArticle}>
            <BusinessButton link={latestArticleUrl} color="black" buttonText="Back to access" autoMargin={false} />
        </div>
    );
};
export default B2BBackToLatestArticle;
